/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Ai_App_Rescue_Audit_Desc5Inputs */

const en_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Full review of your AI-built app: bugs, security holes and what blocks launch, priced before work starts.`)
};

const ar_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`مراجعة كاملة لتطبيقك المبني بالذكاء الاصطناعي: الأخطاء والثغرات الأمنية وما يحجب الإطلاق، بسعر قبل بدء العمل.`)
};

const bn_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`আপনার এআই-বানানো অ্যাপের পূর্ণ পর্যালোচনা: বাগ, নিরাপত্তা গর্ত আর লঞ্চে কী বাধা, কাজ শুরুর আগেই দাম।`)
};

const de_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Komplette Prüfung Ihrer KI-gebauten App: Fehler, Sicherheitslücken und was den Start blockiert, bepreist vor Arbeitsbeginn.`)
};

const es_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisión completa de su app creada con IA: errores, agujeros de seguridad y lo que bloquea el lanzamiento, con precio antes de empezar.`)
};

const fr_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revue complète de votre app construite par IA : bugs, failles de sécurité et ce qui bloque le lancement, tarifé avant de commencer.`)
};

const pt_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Revisão completa da sua app criada com IA: erros, falhas de segurança e o que bloqueia o lançamento, com preço antes de começar.`)
};

const zh_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全面审查你的 AI 搭建应用：缺陷、安全漏洞和上线卡点，开工前先报价。`)
};

const tr_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`YZ ile kurduğunuz uygulamanın tam incelemesi: hatalar, güvenlik açıkları ve lansmanı engelleyenler, işe başlamadan fiyatlı.`)
};

const ru_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Полный разбор вашего ИИ-построенного приложения: баги, дыры в безопасности и что блокирует запуск, с ценой до старта работ.`)
};

const pl_svc_ai_app_rescue_audit_desc5 = /** @type {(inputs: Svc_Ai_App_Rescue_Audit_Desc5Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pełny przegląd aplikacji zbudowanej przez AI: błędy, dziury bezpieczeństwa i to, co blokuje start, wycenione przed pracą.`)
};

/**
* | output |
* | --- |
* | "Full review of your AI-built app: bugs, security holes and what blocks launch, priced before work starts." |
*
* @param {Svc_Ai_App_Rescue_Audit_Desc5Inputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
const svc_ai_app_rescue_audit_desc5 = /** @type {((inputs?: Svc_Ai_App_Rescue_Audit_Desc5Inputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Ai_App_Rescue_Audit_Desc5Inputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "bn") return bn_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "de") return de_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "es") return es_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "fr") return fr_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "pt") return pt_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "zh") return zh_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "tr") return tr_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "ru") return ru_svc_ai_app_rescue_audit_desc5(inputs)
	if (locale === "pl") return pl_svc_ai_app_rescue_audit_desc5(inputs)
	return en_svc_ai_app_rescue_audit_desc5(inputs)
});
export { svc_ai_app_rescue_audit_desc5 as "svc_ai-app-rescue_AUDIT_desc" }